import React, { useState } from "react";
import userAvatar from "assets/img/user.svg";
import Loader from "components/Loader";
import { useUserContext } from "store/contexts/userContext";
import TeamService from "services/TeamService";
import { CSSTransition } from "react-transition-group";
import * as moment from "moment";
import { useTimelineContext } from "store/contexts/timelineContext";
import PostReactionDailogue from "./ReactionDailogue";

var styles = {
  buzzUserImage: {
    minWidth: "29px",
    minHeight: "29px",
    maxWidth: "29px",
    maxHeight: "29px",
    borderRadius: "50%",
    overflow: "hidden",
    padding: "0",
    objectFit: "cover",
  },
  buzzUsersCount: {
    fontSize: "12px",
    fontWeight: "400",
  },
};

export default ({ post, openEngagement }) => {
  const classes = styles;
  const { user } = useUserContext();
  const { updatePost, setHide, innovation_dashboard, company_id } = useTimelineContext();
  const [showReactions, setShowReaction] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dialogState, setDialogState] = useState(false);
  const moreReaction = {
    display: "flex",
    justifyContent: "center",
    color: "rgb(0 0 0 / 75%)",
    fontWeight: "400",
    padding: "5px 10px",
  };

  const showReactionUserList = async (event) => {
    setShowReaction(event.currentTarget);

    if (!post.reactions) {
      setLoading(true);

      await getReactionDetails();
    }
  };

  const getReactionDetails = async () => {
    try {
      var response;

      if(innovation_dashboard) {
        response = await TeamService.getBuzzlistCompanyPost(
          company_id,
          post?.id
        );
      }

      if(!innovation_dashboard) {
        response = await TeamService.getBuzzlistPost(
          post?.team_id,
          post?.id
        );
      }

      updatePost({
        ...post,
        reactions: response?.data?.data,
      });
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const hideReactionUserList = () => {
    setShowReaction(null);
  };

  const showDailogue = () => {
    if (!post?.buzzes_count) return;
    setShowReaction(null);
    setDialogState(true);
    setHide(true);
  };

  return (
    <>
      <div className="post-reactions">
        <div
          className="reaction-counter"
          onMouseEnter={showReactionUserList}
          onMouseLeave={hideReactionUserList}
          onClick={showDailogue}
        >
          {post?.buzzes_count > 0 && (
            <>
              <img
                src={
                  (post?.buzz_type_id === null
                    ? post?.recent_buzz_activity_user?.avatar
                    : user?.avatar) ?? userAvatar
                }
                alt={`${post?.recent_buzz_activity_user?.full_name}`}
                style={classes.buzzUserImage}
              />
              <span style={classes.buzzUsersCount}>
                {`
              ${
                post?.buzz_type_id !== null
                  ? "You"
                  : post?.recent_buzz_activity_user?.full_name
              }
              ${
                post?.buzzes_count > 1
                  ? ` & ${post?.buzzes_count - 1} other`
                  : ""
              }
              Reacted
            `}
              </span>
            </>
          )}
          {post?.expressions_count > 0 && (
            <>
              {!post?.buzzes_count && (
                <>
                  <img
                    src={
                      (!post?.user_expressed
                        ? post?.recent_expressed_activity_user?.avatar
                        : user?.avatar) ?? userAvatar
                    }
                    alt={`${post?.recent_expressed_activity_user?.full_name}`}
                    style={classes.buzzUserImage}
                  />
                  <span style={classes.buzzUsersCount}>
                    {`
                  ${
                    post?.user_expressed
                      ? "You"
                      : post?.recent_expressed_activity_user?.full_name
                  }
                  ${
                    post?.expressions_count > 1
                      ? ` & ${post?.expressions_count - 1} other`
                      : ""
                  }
                  Engaged
                `}
                  </span>
                </>
              )}
              {!!post?.buzzes_count && (
                <>
                  <span
                    style={classes.buzzUsersCount}
                  >{` & ${post?.expressions_count} Engaged`}</span>
                </>
              )}
            </>
          )}
          <CSSTransition
            in={Boolean(showReactions)}
            timeout={300}
            unmountOnExit
            classNames="dropdown-element"
          >
            <div className="reactionListContent">
              <div className="reactionListContainer">
                {loading && <Loader width={40} height={40} />}
                <div>
                  {post?.reactions &&
                    post?.reactions?.slice(0, 5).map((response, index) => (
                      <ul key={index} className="displayReactionList">
                        <li key={response.id} className="displayReactionList">
                          <p className="muiListItem">
                            <span className="displayReactionName">
                              <span>
                                {response?.user?.id === user?.id
                                  ? "You Reacted At "
                                  : response?.user?.full_name}
                              </span>
                              <span className="displayDate">
                                {moment(response?.user?.responded_at).format(
                                  "MMM DD, YYYY"
                                )}
                              </span>
                            </span>
                          </p>
                        </li>
                      </ul>
                    ))}
                  {post?.buzzes_count > 5 && (
                    <div style={moreReaction}>
                      <span>and {post?.buzzes_count} more</span>
                    </div>
                  )}
                </div>
                {post.reactions && post.reactions.length === 0 && !loading && (
                  <div style={moreReaction}>No Reaction</div>
                )}
              </div>
            </div>
          </CSSTransition>
        </div>
        <div className="post_stats">
          <span className="comments" onClick={openEngagement}>
            {post?.expressions_count} Engagements{" "}
          </span>
        </div>
      </div>
      {post?.reactions?.length !== 0 && !loading && (
        <PostReactionDailogue
          loading={loading}
          data={post}
          dialogState={dialogState}
          setDialogState={setDialogState}
        />
      )}
    </>
  );
};
